export default (params = {}) => ({
  cookieKey: '',
  isVisible: false,

  init() {
    // Sanitize cookie key - only allow alphanumeric, hyphens, and underscores
    const rawKey = params.cookieKey || 'marketing_notification';
    this.cookieKey = rawKey.replace(/[^a-zA-Z0-9_-]/g, '_');

    // Check if the notification has been dismissed
    if (!this.getCookie(this.cookieKey)) {
      this.$nextTick(() => {
        this.isVisible = true;
      });
    }
  },

  dismiss() {
    this.isVisible = false;
    // Set cookie to expire in 30 days
    this.setCookie(this.cookieKey, "dismissed", 30);
  },

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  },

  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  },
});
